// src/components/TBAdminLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import "./Login.css"; 

const TBAdminlogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  
  const adminEmail = "shanussh@gmail.com";
  const adminPassword = "Tabl@123";

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Checking if email and password match the hardcoded ones
      if (email === adminEmail && password === adminPassword) {
        enqueueSnackbar("Welcome TBAdmin!", { variant: "success" });
        navigate("/tbadmin/signup"); // Redirecting to the admin signup page
      } else {
        enqueueSnackbar("Unauthorized TBAdmin access", { variant: "error" });
      }
    } catch (err) {
      enqueueSnackbar(err.message, { variant: "error" });
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2>TBAdmin Login</h2>
        <form onSubmit={handleLogin} className="login-form">
          <input
            type="email"
            placeholder="Admin Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Admin Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit" className="login-button">Login as Admin</button>
        </form>
      </div>
    </div>
  );
};

export default TBAdminlogin;
